// extracted by mini-css-extract-plugin
module.exports = {"margin-lg":"_3nIns2","margin-md":"_2ZiXs3","margin-sm":"_1ZF7rN","subTitle":"qFVZXS","margin--md":"_2M8VJx","shine-lines":"f4kKjW"};